import { render, staticRenderFns } from "./course_schoolorder_management.vue?vue&type=template&id=a26d2acc&scoped=true&"
import script from "./course_schoolorder_management.vue?vue&type=script&lang=js&"
export * from "./course_schoolorder_management.vue?vue&type=script&lang=js&"
import style0 from "./course_schoolorder_management.vue?vue&type=style&index=0&id=a26d2acc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26d2acc",
  null
  
)

export default component.exports